<template>
  <div class="confirm-tip">
    <div>
      <span v-if="simple">
        确定要执行
        <span class="stress">
          {{ action }}
        </span>
        操作吗？
      </span>
      <span v-else-if="!msg">
        确定要对选中的
        <span class="stress">
          {{ targets.length }}
        </span>
        个对象执行
        <span class="stress">
          {{ action }}
        </span>
        操作吗？
      </span>
      <span
        v-else
        v-html="msg"
      />
    </div>
    <div>
      <span
        v-for="(d,i) in targets"
        :key="i+'_'+d.name"
      >
        {{ i > 0 && d.name ? ', ' + d.name : d.name }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmTip',
  props: {
    action: {
      type: String,
      required: true
    },
    simple: {
      type: Boolean,
      default: false
    },
    targets: {
      type: Array,
      default: () => []
    },
    msg: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less">
  .stress {
    font-weight: 800;
    margin: 0 5px;
  }

  .confirm-tip > div {
    padding: 1px 0;
  }

  .popup-alert-info-content {
    font-size: 14px;
    font-weight: bold;
  }
  .blue{
    color:#40a9ff
  }
</style>
